import TicketCreateGeneralInformation from './TicketCreateGeneralInformation';

export default TicketCreateGeneralInformation;
